<template>
  <div class="uc-layout">
    <div class="content-wrap">
      <header>
        <h1></h1><label>用户中心</label>
      </header>
      <main>
        <router-view/>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UCLayout'
}
</script>

<style scoped lang="scss">
@import "../assets/style/themeify";
@include themeify {
  .uc-layout {
    .content-wrap {
      width: 1120px;
      margin: 0 auto;
    }
    header {
      height: 60px;
      h1 {
        width: 150px;
        background: url(themed('logo-url')) no-repeat;
        background-size: auto 30px;
        background-position: center;
        height: 100%;
        display: inline-block;
      }
      label {
        color: themed('font-color');
        font-size: 18px;
        margin-left: 6px;
      }
    }
  }
}
</style>
